<template>
  <div>
    <div class="button-bar">
      <div class="items1">
        <WDStepTitle
          :propsMode="propsMode"
          :quoteType="quoteType"
          :quoteId="quoteId"
          :status="vehicle.status"
        />
      </div>
      <div class="items2">
        <div>
          <button
            v-if="
              propsData.status == 1 ||
              propsData.status == 21 ||
              getIsLock == false
            "
            type="button"
            class="btn btn-primary btn-sm mr-2"
            @click="fnCompleteApplication(false)"
          >
            <i class="las la-share-square"></i>Complete Application
          </button>
          <button
            v-if="propsData.status == 1 || propsData.status == 21"
            class="btn btn-success btn-sm mr-2"
            data-toggle="tooltip"
            data-placement="top"
            title="Save quote"
            @click="fnSaveApplication(true)"
          >
            <i class="lar la-save"></i>Save
          </button>
        </div>
        <div v-if="fnIsShowUnlockButton()">
          <div>
            <appModalUnlockMessage
              :propsData="propsData"
              v-if="getIsLock == true"
            ></appModalUnlockMessage>
            <button
              v-if="getIsLock != true"
              class="btn btn-success btn-sm"
              data-toggle="tooltip"
              data-placement="top"
              title="Save quote"
              @click="fnSaveApplication(true)"
            >
              <i class="lar la-save"></i>Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-12 col-md-12 col-12">
        <h5 class="mb-3 text-info">Application Notes</h5>
      </div>
      <div class="col-12">
        <div class="form-group">
          <textarea
            class="form-control"
            type="text"
            rows="4"
            id="applicationNotes"
            autocomplete="off_applicationNotes"
            placeholder=" "
            v-model="notes.applicationNotes"
          >
          </textarea>
          <label class="floatingLabel" for="applicationNotes">Notes</label>
        </div>
      </div>
    </div>

    <!-- Dealer and Dealer Staff -->
    <div
      class="row mt-3"
      id="uploadDocuments"
      v-if="userData.role_id == 3 || this.userData.role_id == 4"
    >
      <div class="col-lg-12 col-md-12 col-12">
        <div class="row">
          <div class="col-12">
            <h5 class="mb-0 text-info">Document Upload</h5>
            <p class="mb-0 text-primary">
              For us to be able to submit a full application we will need a copy
              of the following documents.
            </p>
          </div>
        </div>
        <div class="row mt-3 mb-5">
          <div class="col-xl-2 col-lg-2 col-md-2 col-12">
            <h5 class="mb-0 text-dark-light pb-2">Applicant</h5>
            <p class="mb-0">Latest payslip</p>
            <p class="mb-0">Driver’s license (front & rear)</p>
            <p class="mb-0">Signed privacy form</p>
            <p class="mb-0">Proof of any additional income</p>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-12">
            <h5 class="mb-0 text-dark-light pb-2">
              Spouse/Partner (if required for capacity)
            </h5>
            <p class="mb-0">Latest payslip</p>
            <p class="mb-0">Signed partner privacy consent from</p>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-12">
            <h5 class="mb-0 text-dark-light pb-2">Uploaded documents</h5>
            <div class="pb-3">
              <div class="tag-input files-columns">
                <template v-for="(image, index) in getDealerShipDocs">
                  <div :key="index">
                    <div class="tag-input__tag">
                      <div v-if="image.fileName">
                        <span
                          ><a :href="`${image.url}`" target="_blank"
                            ><span v-if="image.aliasName">{{
                              image.aliasName
                            }}</span>
                            <span v-else>Doc - {{ index + 1 }}</span></a
                          >
                        </span>
                        <span
                          v-if="getIsLock == false || propsData.status == 1"
                          @click="fnDocumentRemove(image.id)"
                          class="pl10"
                          v-b-tooltip.right="'Remove file'"
                          ><i class="far fa-times-circle"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-12">
            <div v-if="quoteType == 'quote'">
              <vue-dropzone
                v-if="getIsLock == false || propsData.status == 1"
                ref="docUploadDropzone"
                id="docUploadDropzone"
                :useCustomSlot="true"
                :options="dropzoneOptions"
                v-on:vdropzone-sending="fnSendingDocuemt"
                @vdropzone-queue-complete="fnAfterSendingDocuemt"
                class="quoteDocUpload"
              >
                <div class="dropzone-custom-content">
                  <div class="subtitle">
                    <i class="las la-cloud-upload-alt fs-2000 text-info"></i>
                  </div>
                  <h5 class="dropzone-custom-title">
                    Drag and drop to upload file!
                  </h5>
                  <div class="subtitle">
                    ...or click to select a file from your computer
                  </div>
                  <b-spinner small v-if="is_spinActive"></b-spinner>
                  <span v-if="is_spinActive">Uploading...</span>
                </div>
              </vue-dropzone>
            </div>
            <div v-if="quoteType == 'leads'">
              <vue-dropzone
                v-if="getIsLock == false || propsData.status == 1"
                ref="docUploadDropzone"
                id="docUploadDropzone"
                :useCustomSlot="true"
                :options="dropzoneOptionsLeads"
                v-on:vdropzone-sending="fnSendingDocuemt"
                @vdropzone-queue-complete="fnAfterSendingDocuemt"
                class="quoteDocUpload"
              >
                <div class="dropzone-custom-content">
                  <div class="subtitle">
                    <i class="las la-cloud-upload-alt fs-2000 text-info"></i>
                  </div>
                  <h5 class="dropzone-custom-title">
                    Drag and drop to upload file!
                  </h5>
                  <div class="subtitle">
                    ...or click to select a file from your computer
                  </div>
                  <b-spinner small v-if="is_spinActive"></b-spinner>
                  <span v-if="is_spinActive">Uploading...</span>
                </div>
              </vue-dropzone>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Admin and Staff -->
    <div
      class="row mt-3"
      id="uploadDocuments"
      v-if="userData.role_id == 1 || this.userData.role_id == 2"
    >
      <div class="col-lg-12 col-md-12 col-12">
        <div class="row">
          <div class="col-12">
            <h5 class="mb-0 text-info">Document List</h5>
          </div>
        </div>
        <div class="row mt-3 mb-5">
          <div class="col-xl-4 col-lg-4 col-md-4 col-12 mb-3">
            <h5 class="mb-0 text-dark-light pb-2">Dealership Docs</h5>

            <div class="pb-3">
              <div class="tag-input files-columns">
                <template v-for="(image, index) in getDealerShipDocs">
                  <div :key="index">
                    <div class="tag-input__tag">
                      <div v-if="image.fileName">
                        <span
                          ><a :href="`${image.url}`" target="_blank"
                            ><span v-if="image.aliasName">{{
                              image.aliasName
                            }}</span>
                            <span v-else>Doc - {{ index + 1 }}</span></a
                          >
                        </span>
                        <span
                          v-if="getIsLock == false || propsData.status == 1"
                          @click="fnDocumentRemove(image.id)"
                          class="pl10"
                          v-b-tooltip.right="'Remove file'"
                          ><i class="far fa-times-circle"></i
                        ></span>
                      </div>
                    </div>
                    <span
                      v-if="getIsLock == false || propsData.status == 1"
                      class=""
                      v-b-tooltip.right="'Change file name'"
                      @click="fnOpenModalDocumentAliasName(image.id)"
                    >
                      <i class="las la-pen mt1200"></i>
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-12 mb-3">
            <h5 class="mb-0 text-dark-light pb-2">VSA Docs</h5>

            <div class="pb-3">
              <div class="tag-input files-columns">
                <template v-for="(image, index) in getAdminDocs">
                  <div :key="index">
                    <div class="tag-input__tag">
                      <div v-if="image.fileName">
                        <span
                          ><a :href="`${image.url}`" target="_blank"
                            ><span v-if="image.aliasName">{{
                              image.aliasName
                            }}</span>
                            <span v-else>VSA Doc - {{ index + 1 }}</span></a
                          >
                        </span>
                        <span
                          v-if="getIsLock == false || propsData.status == 1"
                          @click="fnDocumentRemove(image.id)"
                          class="pl10"
                          v-b-tooltip.right="'Remove file'"
                          ><i class="far fa-times-circle"></i
                        ></span>
                      </div>
                    </div>
                    <span
                      v-if="getIsLock == false || propsData.status == 1"
                      class=""
                      v-b-tooltip.right="'Change file name'"
                      @click="fnOpenModalDocumentAliasName(image.id)"
                    >
                      <i class="las la-pen mt1200"></i>
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-12">
            <!-- Select the file upload section either VSA or Dealer -->
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_title"
                placeholder=" "
                :options="optionDocType"
                v-model="docTypeId"
              ></b-form-select>
              <label class="floatingLabel" for="title"
                >Select document for VSA / Dealer</label
              >
            </div>

            <div v-if="quoteType == 'quote'">
              <vue-dropzone
                v-if="getIsLock == false && this.docTypeId"
                ref="docUploadDropzone"
                id="docUploadDropzone"
                :useCustomSlot="true"
                :options="dropzoneOptions"
                v-on:vdropzone-sending="fnSendingDocuemtAdmin"
                @vdropzone-queue-complete="fnAfterSendingDocuemtAdmin"
                class="quoteDocUpload"
              >
                <div class="dropzone-custom-content">
                  <div class="subtitle">
                    <i class="las la-cloud-upload-alt fs-2000 text-info"></i>
                  </div>
                  <h5 class="dropzone-custom-title">
                    Drag and drop to upload file!
                  </h5>
                  <div class="subtitle">
                    ...or click to select a file from your computer
                  </div>
                  <b-spinner small v-if="is_spinActive"></b-spinner>
                  <span v-if="is_spinActive">Uploading...</span>
                </div>
              </vue-dropzone>
            </div>

            <div v-if="quoteType == 'leads'">
              <vue-dropzone
                v-if="getIsLock == false && this.docTypeId"
                ref="docUploadDropzone"
                id="docUploadDropzone"
                :useCustomSlot="true"
                :options="dropzoneOptionsLeads"
                v-on:vdropzone-sending="fnSendingDocuemtAdmin"
                @vdropzone-queue-complete="fnAfterSendingDocuemtAdmin"
                class="quoteDocUpload"
              >
                <div class="dropzone-custom-content">
                  <div class="subtitle">
                    <i class="las la-cloud-upload-alt fs-2000 text-info"></i>
                  </div>
                  <h5 class="dropzone-custom-title">
                    Drag and drop to upload file!
                  </h5>
                  <div class="subtitle">
                    ...or click to select a file from your computer
                  </div>
                  <b-spinner small v-if="is_spinActive"></b-spinner>
                  <span v-if="is_spinActive">Uploading...</span>
                </div>
              </vue-dropzone>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Privacy Consent -->
    <appModalPrivacyConsent
      ref="refModalPrivacyConsent"
      :propsData="propsData"
      :quoteId="quoteId"
      :quoteType="quoteType"
    ></appModalPrivacyConsent>
    <!-- Privacy Consent -->

    <appModalDocumentAliasName
      ref="modalDocumentAliasName"
      :documentId="documentId"
      :quoteId="quoteId"
      :quoteType="quoteType"
    ></appModalDocumentAliasName>

    <ModalQuoteSubmitConfirm
      ref="modalQuoteSubmitConfirm"
      :propsData="propsData"
      :quoteType="quoteType"
    ></ModalQuoteSubmitConfirm>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../services/auth.service'
import * as messageService from '../../services/message.service'
import * as clientDocumentService from '../../services/clientDocument.service'
import * as leadsService from '../../services/leads.service'
import appModalDocumentAliasName from './ModalDocumentAliasName.vue'
import appModalUnlockMessage from '../../components/quote/ModalUnlockMessage.vue'
import appModalPrivacyConsent from '../../components/quote/ModalPrivacyConsent.vue'
import WDStepTitle from '../../components/wd/WDStepTitle.vue'
import ModalQuoteSubmitConfirm from '../../components/quote/ModalQuoteSubmitConfirm.vue'

import store from '../../store/modules/base.module'
import vueDropzone from 'vue2-dropzone'
import {
  optionDocType,
  optionThereIsAMortgageYesNo
} from '../../services/data.service'

export default {
  name: 'quoteStep5',
  props: ['propsMode', 'propsData', 'quoteType'],
  components: {
    vueDropzone,
    appModalDocumentAliasName,
    appModalUnlockMessage,
    appModalPrivacyConsent,
    WDStepTitle,
    ModalQuoteSubmitConfirm
  },
  data() {
    return {
      userData: {},
      errors: {},
      quoteId: this.$route.params.quoteId,
      documentId: '',
      is_spinActive: false,
      privacyConsent: 0,
      step: 5,
      isSave: false,
      // client_vehicle_details
      vehicle: {
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: '',
        salaryPackagingProviderId: '',
        salaryPackagingProviderFee: '',
        vehicleCondition: '',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: '',
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: '',
        fuelTypeId: '',
        colour: '',
        accessories: '',
        term: '',
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: '',
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: '',
        stampDuty: 0,
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: '',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: '',
        dealerBrokerage: '',
        status: '',
        sortOrder: '',
        has_messages: '',
        messages_for_vsa: '',
        messages_for_other: '',
        privacyConsent: '',
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: '',
        dateOfBirth: '',
        anotherNameYesNo: '',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: '',
        maritalStatus: '',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: '',
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: '',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: '',
        hAddressTimeAtYears: '',
        hAddressTimeAtMonths: '',
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: '',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: '',
        postalAddressAndHomeAddressAreSameYesNo: '',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      },
      //client_employment_details
      employment: {
        quoteId: '',
        employerName: '',
        tradingName: '',
        ABNOfEmployerOnPayslip: '',
        websiteAddress: '',
        employmentStatus: '',
        occupation: '',
        employerAddressBuildingName: '',
        employerAddressUnitNumber: '',
        employerAddressStreetNumber: '',
        employerAddressStreetName: '',
        employerAddressSuburb: '',
        employerAddressState: '',
        employerAddressPostcode: '',
        employerAddressTimeAtYears: 0,
        employerAddressTimeAtMonths: 0,
        employerContactName: '',
        employerContactNumber: '',
        pEmployerName: '',
        pABNOfEmployerOnPayslip: '',
        pEmploymentStatus: '',
        pOccupation: '',
        pEmployerAddressBuildingName: '',
        pEmployerAddressUnitNumber: '',
        pEmployerAddressStreetNumber: '',
        pEmployerAddressStreetName: '',
        pEmployerAddressSuburb: '',
        pEmployerAddressState: '',
        pEmployerAddressPostcode: '',
        pEmployerAddressTimeAtYears: 0,
        pEmployerAddressTimeAtMonths: 0,
        pEmployerContactName: '',
        pEmployerContactNumber: '',
        investmentIncome: '',
        govConvertibleIncome: '',
        otherIncome: '',
        noteOnOtherIncome: ''
      },
      //client_finance_details
      finance: {
        quoteId: '',
        homePropertyValve: '',
        investmentProperty: [
          {
            value: '',
            limit: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        vehicleProperty: [
          {
            value: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        otherMajorVehicles: '',
        superannuationBalance: '',
        toolsAndEquipment: '',
        sharesTrustsSMSF: '',
        cashInTheBank: '',
        homeContents: '',
        otherMajorAsset: '',
        listOtherMajorAsset: '',
        homeLoanBalance: '',
        homeLoanLimit: '',
        homeLoanLenderName: '',
        homeLoanMonthlyPayment: '',
        personalLoan: [
          {
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        creditCard: [
          {
            limit: '',
            lenderName: ''
          }
        ],
        privateSchoolFees: '',
        vehicleRunningCosts: '',
        livingExpenses: '',
        insurances: '',
        ratesPowerWater: '',
        entertainment: '',
        otherMajorMonthlyExpenses: '',
        totalMonthlyExpenses: ''
      },
      //client_application_notes
      notes: {
        applicationNotes: ''
      },
      //lookup value
      lookupValues: {
        FBTRate: '0',
        GAPInsurance: '0',
        GAPInsuranceVSA: '0',
        GST: '0',
        GSTLimit: '0',
        GSTMaxOnAssets: '0',
        PPSRFee: '0',
        brokerage: '0',
        brokerageVSADefault: '0',
        brokerageVSA: '0',
        id: -1,
        financierId: -1,
        interest: '0',
        leaseAdminFee: '0',
        leaseAdminFeeVSA: '0',
        mcLeaseFee: '0',
        medicare: '0',
        quoteId: -1,
        registration: '0',
        tyreReplaceFreq: '0',
        tyreWheelInsurance: '0'
      },
      serverPath: store.state.serverPath,
      dropzoneOptions: {
        url: `${store.state.apiURL}/client-document/upload`,
        headers: {
          Authorization: `Bearer ${authService.getAccessToken()}`
        },
        thumbnailWidth: 75,
        maxFilesize: 20,
        uploadMultiple: true,
        maxFiles: 10,
        paralleUploads: 10,
        previewsContainer: false,
        acceptedFiles: '.pdf, .docx, .doc, .xlsx, .xls, .jpg, .jpeg, .png'
      },
      dropzoneOptionsLeads: {
        url: `${store.state.apiURL}/leads-document/upload`,
        headers: {
          Authorization: `Bearer ${authService.getAccessToken()}`
        },
        thumbnailWidth: 75,
        maxFilesize: 20,
        uploadMultiple: true,
        maxFiles: 10,
        paralleUploads: 10,
        previewsContainer: false,
        acceptedFiles: '.pdf, .docx, .doc, .xlsx, .xls, .jpg, .jpeg, .png'
      },
      docTypeId: '',
      optionDocType: optionDocType,
      optionThereIsAMortgageYesNo: optionThereIsAMortgageYesNo
    }
  },
  computed: {
    ...mapGetters([
      'getSettingAll',
      'getStepNumber',
      'getQuoteSingle',
      'getIsLock',
      'getQuoteErrors'
    ]),
    getDealerShipDocs() {
      let client_documents = this.propsData.client_documents
      let docs = []

      if (client_documents) {
        docs = client_documents.filter(function (doc) {
          return doc.documentTypeId == 10
        })
      }

      return docs
    },
    getAdminDocs() {
      let client_documents = this.propsData.client_documents
      let docs = []
      if (client_documents) {
        docs = client_documents.filter(function (doc) {
          return doc.documentTypeId == 11
        })
      }

      return docs
    },

    uploadOption() {
      if (this.quoteType == 'leads') {
        return this.dropzoneOptionsLeads
      }

      return this.dropzoneOptions
    }
  },
  methods: {
    ...mapActions([
      'fetchStepNumber',
      'fetchQuoteSingle',
      'fetchIsLock',
      'fetchQuoteErrors',
      'fetchSaveApplication'
    ]),

    // Dropzone document upload
    fnSendingDocuemt(file, xhr, formData) {
      this.is_spinActive = true
      formData.append('quoteId', this.quoteId)
      formData.append('documentTypeId', 10)
    },
    // Dropzone document upload by Admins
    fnSendingDocuemtAdmin(file, xhr, formData) {
      this.is_spinActive = true
      formData.append('quoteId', this.quoteId)
      formData.append('documentTypeId', this.docTypeId)
    },
    // Dropzone document upload after
    fnAfterSendingDocuemt(file) {
      this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      this.is_spinActive = false
    },
    // Dropzone document upload after Admins
    fnAfterSendingDocuemtAdmin(file) {
      this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      this.is_spinActive = false
    },
    // Document remove in file storage and database
    fnDocumentRemove: async function (id) {
      try {
        this.is_spinActive = true
        let response = ''

        if (this.quoteType == 'quote') {
          response = await clientDocumentService.documentRemove(id)
        }

        if (this.quoteType == 'leads') {
          response = await leadsService.documentRemove(id)
        }

        this.errors = {}
        this.is_spinActive = false
        this.fetchQuoteSingle({
          id: this.quoteId,
          quoteType: this.quoteType
        })

        messageService.fnSweetAlertSuccessToast(
          'Document removed',
          response.data.message
        )
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Document removed',
          'Something wrong, please try again!'
        )
      }
    },

    fnCompleteApplication: async function (isSave) {
      this.isSave = isSave
      /**
       * Quote or Leads if unlocked save first
       */
      if (this.getIsLock != true) {
        // Save application notes before load the modal
        await this.fnSaveApplication(true)

        this.$refs.refModalPrivacyConsent.fnModalShow()

        return
      }
    },

    fnCompleteApplication2: async function (isSave) {
      this.isSave = isSave
      /**
       * If locked exist then go out else do process
       * if quoteType, leads then status id 21 or 22 is lead quote
       */
      if (
        this.propsData.status == 1 ||
        this.propsData.status == 7 ||
        this.propsData.status == 8 ||
        this.propsData.status == 13 ||
        this.propsData.status == 14 ||
        this.propsData.status == 21 ||
        this.propsData.status == 22 ||
        this.propsData.status == 24 ||
        this.propsData.status == 25 ||
        this.propsData.status == 26
      ) {
        // Save application notes before load the modal
        await this.fnSaveApplication(true)

        this.$refs.refModalPrivacyConsent.fnModalShow()

        return
      }
      /**
       * Leads Status
       */
      if (
        this.getIsLock != true &&
        this.propsData.status != 21 &&
        this.quoteType == 'leads'
      ) {
        /**
         * On submit and call Emended
         * status = 23
         */
        this.vehicle.status = 23
        await this.fnCallSubmit()

        // To lock
        this.fetchIsLock(true)

        return
      }
    },

    fnCallSubmit: async function () {
      const allData = {
        quoteType: this.quoteType,
        submit_mode: 'submit',
        quoteId: this.quoteId,
        vehicle: this.vehicle,
        client: this.client,
        employment: this.employment,
        finance: this.finance,
        lookupValues: this.lookupValues,
        notes: this.notes
      }
      await this.fetchSaveApplication(allData)
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      //this.fnModalPrivacyConsentMessageHide()

      this.$refs.refModalPrivacyConsent.fnModalHide()
    },

    /**
     * Save values
     */
    fnSaveApplication: async function (isSave) {
      this.isSave = isSave

      const allData = {
        quoteType: this.quoteType,
        propsMode: this.propsMode,
        submit_mode: 'save',
        quoteId: this.quoteId,
        vehicle: this.vehicle,
        client: this.client,
        employment: this.employment,
        finance: this.finance,
        lookupValues: this.lookupValues,
        notes: this.notes
      }

      await this.fetchSaveApplication(allData)
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      this.fnCallModalQuoteSubmitConfirm()
    },

    /**
     * To Show Unlock button
     */
    fnIsShowUnlockButton() {
      let status = false

      if (this.propsMode == 'edit') {
        if (
          this.propsData.status != 1 &&
          this.propsData.status != 7 &&
          this.propsData.status != 8 &&
          this.quoteType == 'quote'
        ) {
          status = true
        }

        if (
          this.propsData.status != 21 &&
          this.propsData.status != 22 &&
          this.propsData.status != 24 &&
          this.propsData.status != 25 &&
          this.propsData.status != 26 &&
          this.quoteType == 'leads'
        ) {
          status = true
        }
      }

      return status
    },
    fnOpenModalDocumentAliasName(documentId) {
      this.documentId = documentId

      this.$refs.modalDocumentAliasName.fnShowModal()
    },
    fnReplace(str) {
      const newString = str.toString().replace('[', '').replace(']', '')

      return newString
    },
    /**
     * Call Modal which is used to update quote status
     * if quote status in 13 or 14 into 3
     */
    fnCallModalQuoteSubmitConfirm() {
      if (this.vehicle.status == 13 || this.vehicle.status == 14) {
        const childComponent = this.$refs.modalQuoteSubmitConfirm
        if (childComponent) {
          childComponent.fnModalShow()
        }
      }
    }
  },
  created() {
    this.userData = authService.getUserFromToken()
  },
  watch: {
    propsData(newValue) {
      this.vehicle.clientId = newValue.clientId
      this.vehicle.dealerId = newValue.dealerId
      this.vehicle.referralPartnerId = newValue.referralPartnerId
      this.vehicle.referDealerId = newValue.referDealerId
      this.vehicle.leadSource = newValue.leadSource
      this.vehicle.salaryPackagingProviderId =
        newValue.salaryPackagingProviderId
      this.vehicle.salaryPackagingProviderFee =
        newValue.salaryPackagingProviderFee
      this.vehicle.vehicleCondition = newValue.vehicleCondition
      this.vehicle.odometerReading = newValue.odometerReading
      this.vehicle.year = newValue.year
      this.vehicle.make = newValue.make
      this.vehicle.model = newValue.model
      this.vehicle.variant = newValue.variant
      this.vehicle.bodyType = newValue.bodyType
      this.vehicle.vehicleCategoryId = newValue.vehicleCategoryId
      this.vehicle.fuelFlatRate = newValue.fuelFlatRate
      this.vehicle.fuelCostPerKM = newValue.fuelCostPerKM
      this.vehicle.tyresCostPerKM = newValue.tyresCostPerKM
      this.vehicle.serviceCostPerKM = newValue.serviceCostPerKM
      this.vehicle.transmissionId = newValue.transmissionId
      this.vehicle.fuelTypeId = newValue.fuelTypeId
      this.vehicle.colour = newValue.colour
      this.vehicle.accessories = newValue.accessories
      this.vehicle.term = newValue.term
      this.vehicle.rvRate = newValue.rvRate
      this.vehicle.annualKms = newValue.annualKms
      this.vehicle.noFinanceInsurance = newValue.noFinanceInsurance
      this.vehicle.comprehensiveInsurer = newValue.comprehensiveInsurer
      this.vehicle.comprehensiveInsurancePremium =
        newValue.comprehensiveInsurancePremium
      this.vehicle.businessUsePercentage = newValue.businessUsePercentage
      this.vehicle.stampDuty = newValue.stampDuty
      this.vehicle.registration = newValue.registration
      this.vehicle.gstOnAsset = newValue.gstOnAsset
      this.vehicle.gstOnAssetActual = newValue.gstOnAssetActual
      this.vehicle.totalDriveAwayCost = newValue.totalDriveAwayCost
      this.vehicle.chanageBudgetsYesNo = newValue.chanageBudgetsYesNo
      this.vehicle.fuelBudget = newValue.fuelBudget
      this.vehicle.serviceBudget = newValue.serviceBudget
      this.vehicle.tyreBudget = newValue.tyreBudget
      this.vehicle.needToCompeteYesNo = newValue.needToCompeteYesNo
      this.vehicle.dealerBrokerage = newValue.dealerBrokerage
      this.vehicle.status = newValue.status
      this.vehicle.sortOrder = newValue.sortOrder
      this.vehicle.has_messages = newValue.has_messages
      this.vehicle.messages_for_vsa = newValue.messages_for_vsa
      this.vehicle.messages_for_other = newValue.messages_for_other
      this.vehicle.privacyConsent = newValue.privacyConsent
      this.vehicle.settlementDate = newValue.settlementDate
      this.vehicle.fa_no = newValue.fa_no
      this.vehicle.edd = newValue.edd

      Object.assign(this.client, newValue.client)
      Object.assign(this.employment, newValue.client_employment_detail)
      Object.assign(this.finance, newValue.client_finance_detail)
      Object.assign(this.notes, newValue.client_application_notes)
      Object.assign(this.lookupValues, newValue.client_lookup_values)
    }
  }
}
</script>
<style lang="scss" scoped>
.files-columns {
  overflow-y: scroll;
  min-height: 300px;
}
</style>
